import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import {
  AddReviewPlatformBatchPayload,
  AddReviewPlatformBatchResponse,
} from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

interface UseAddReviewAnalysisPlatformsBatchMutationParams {
  onError?: () => void
  onSuccess?: (response: AddReviewPlatformBatchResponse) => void
}

export const useAddReviewAnalysisPlatformsBatchMutation = (
  campaignId: string,
  { onError, onSuccess }: UseAddReviewAnalysisPlatformsBatchMutationParams = {}
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: AddReviewPlatformBatchPayload) =>
      ReviewAnalysisApiService.addReviewPlatformsBatch(campaignId, payload),
    onError: () => {
      onError?.()
    },
    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_OVERVIEW, campaignId],
      })
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_STATUS, campaignId],
      })
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_CAMPAIGN, campaignId],
      })
      onSuccess?.(response)
    },
  })
}
